/**
 * 格式化时间 yyyy-M-d H:mm:s
 * @param {Boolean} isHMS 是否需要时分秒 默认true需要
 * @param {String} ymdDivision 年月日分割符 默认 -
 * @param {String} hmsDivision 时分秒分隔符 默认 :
 * @returns 时间格式
 */

Date.prototype.toDate = function (isHMS = true, ymdDivision = '-', hmsDivision = ':') {
    let y = this.getFullYear();
    let M = this.getMonth() + 1;
    let d = this.getDate();
    let hms = '';
    if (isHMS) {
        let h = this.getHours();
        let m = this.getMinutes();
        let s = this.getSeconds();
        hms = ` ${h + hmsDivision + (m > 10 ? m : "0" + m) + hmsDivision + s}`;
    }
    return `${y + ymdDivision + M + ymdDivision + d}${hms}`;
}

// vuescroll配置
const scrollOps = {
    bar: {
        background: '#6c757d'
    }
}

/**
 * 把标准时间转换成 2020-01-01格式
 */
function initTime(t) {
  let d = new Date(t).getTime( new Date(t) );
  let time = new Date(d + 8 * 3600 * 1000).toJSON().substr(0, 19).replace('T', ' ').replace(/\./g, '-');
  time = time.split(' ')[0]
  return time;
}

/**
 * 三级联动
 * @param {Object} (array: Array, NoLabel: String, No: String)
 * @returns {Array} Array<String, any>
 */
function linkage({ array, NoLabel, No }) {
  let result = [];
  for (let i = 0; i < array.length; i++) {
    if (array[i][NoLabel] === No) {
      result.push(array[i]);
    }
  }
  return result;
}

export default {
    scrollOps,
    linkage,
    initTime
}



// WEBPACK FOOTER //
// ./src/opr/utils/tool.js